import { useContext, createContext } from "react";

export const CurrentRouteContext = createContext();

export function useCurrentRoute() {
  return useContext(CurrentRouteContext);
}
